import { InMemoryCache } from '@apollo/client';
import introspection from './generated/possible-types';

export const cache = new InMemoryCache({
    possibleTypes: introspection.possibleTypes
});